<script lang="ts">
    import type { ImportAnalyzeContextReasonType } from '../../ColumnSelectPro/ColumnSettingsApi';
    import { MenuContextCustomActions } from '../../MenuDropdown/MenuContextCustomActions';
    import IconCheck from '../../../shared/Icons/IconCheck.svelte';
    import MenuContextIcon from '../../MenuDropdown/MenuContext/MenuContextIcon.svelte';
    import IconCancel from '../../../shared/Icons/IconCancel.svelte';
    import ErrorColor from '../../../shared/ErrorColor.svelte';
    import SuccessColor from '../../../shared/SuccessColor.svelte';
    import { _ } from 'svelte-i18n';
    import IconHelpCenter from '../../../shared/Icons/IconHelpCenter.svelte';
    import InfoColor from '../../../shared/InfoColor.svelte';
    export let reason: ImportAnalyzeContextReasonType;

    let menu = new MenuContextCustomActions();

    function updateMenu(menu: MenuContextCustomActions, reason: ImportAnalyzeContextReasonType) {
        const validationOptions = {
            invalid: {
                icon: IconCancel,
                iconColorComponent: ErrorColor,
            },
            valid: {
                icon: IconCheck,
                iconColorComponent: SuccessColor,
            },
        };

        menu.reset();

        reason.checks.forEach(check => {
            menu.addAction({
                id: $_(check.desc),
                label: $_(check.desc),
                disabled: true,
                visible: true,
                icon: check.valid ? validationOptions.valid.icon : validationOptions.invalid.icon,
                iconColorComponent: check.valid ? validationOptions.valid.iconColorComponent : validationOptions.invalid.iconColorComponent,
                onClick: () => {},
                subMenuIsOpen: false,
                visibleInContextMenu: true,
            });
        });

        menu = menu;
    }

    updateMenu(menu, reason);
</script>

<div class="tr">
    <div class="td">
        <InfoColor>
            <MenuContextIcon {menu} iconSymbol={IconHelpCenter} menuMode="tooltip" />
        </InfoColor>
    </div>
    <div class="td">
        #{reason.index}
    </div>
    {#each reason.original_values as original_value}
        <div class="td">
            {original_value}
        </div>
    {/each}
</div>

<style>
    .tr {
        display: table-row;
    }
    .td {
        display: table-cell;
        padding: 2px 3px;
        border: 1px solid #cccccc;
        vertical-align: middle; /* For vertical centering */
        text-align: left; /* For horizontal centering */
    }
</style>
